/*
 * PageHeaderDialogNames
 *
 * @description
 * Identifiers for dialogs opened by PageHeaderActions
 */
enum PageHeaderDialogs {
    createContact = 'dialog_create_contact',
}

export default PageHeaderDialogs;
